module.exports = __webpack_public_path__ + "static/media/wave-mobile.e0d7f96d.png";